import React from 'react';
import { AppAccess } from 'core/types/app';
import { RoleId } from 'core/types/role';

export function roleGivesAccess(id: RoleId): boolean {
  return id !== 'none';
}

export function hasEnabledApps(appAccess: AppAccess): boolean {
  return (
    appAccess.share.enabled ||
    appAccess.calendar.enabled ||
    appAccess.clock.enabled ||
    appAccess.videos.enabled ||
    appAccess.contentpackages.enabled
  );
}

const Context = React.createContext<AppAccess>({
  manage: { role: 'none', enabled: false },
  share: { role: 'none', enabled: false },
  clock: { role: 'none', enabled: false },
  calendar: { role: 'none', enabled: false },
  videos: { role: 'none', enabled: false },
  contentpackages: { role: 'none', enabled: false },
});

export const AppAccessProvider = Context.Provider;

export function useAppAccess(): AppAccess {
  return React.useContext(Context);
}
